import React from 'react';
import { FormattedMessage } from 'react-intl';
import FaceSadIcon from '~/components/atoms/icon/faceSad/FaceSadIcon';
import styles from './noResults.module.scss';

const NoResults: React.FC = () => {
    return (
        <div className={styles.noResults}>
            <div>
                <FaceSadIcon />
            </div>
            <div role="paragraph">
                <FormattedMessage
                    id="no_result"
                    defaultMessage="Bohužel jsme nenašli žádné výsledky. Zkuste upravit vaše zadání."
                />
            </div>
        </div>
    );
};

export default NoResults;
